import { createSlice } from "@reduxjs/toolkit";

// Define a slice of the Redux store for the client data
const clientSlice = createSlice({
  name: "client",
  initialState: {
    id: "",
    name: "",
    dep_label: "",
    div_label: "",
    entity_label: "",
    logo: "",
    logo_url: "",
    contract_start_date: "",
    contract_end_date: "",
    customer_client_id: "",
    customer_client_name: "",
    loginPayload: {},
    templateName: "",
    customerClassification: null,
  },
  reducers: {
    setClientData: (state, action) => {
      state.id = action.payload?.client_id;
      state.name = action.payload?.name;
      state.dep_label = action.payload?.dep_label;
      state.div_label = action.payload?.div_label;
      state.entity_label = action.payload?.entity_label;
      state.logo = action.payload?.logo;
      state.logo_url = action.payload?.logo_url;
      state.contract_start_date = action.payload?.contract_start_date;
      state.contract_end_date = action.payload?.contract_end_date;
      state.customer_client_id = action.payload?.customer_client_id;
      state.customer_client_name = action.payload?.customer_client_name;
      state.loginPayload = action.payload?.loginPayload;
      state.templateName = action.payload?.templateName;
    },
    setCustomerClassification: (state, action) => {
      state.customerClassification = action.payload;
    },
  },
});

// Export the reducer function and the action creators
export const { setClientData, setCustomerClassification } = clientSlice.actions;
export default clientSlice.reducer;
